export enum RADIUS {
  _4 = '4px',
  _6 = '6px',
  _8 = '8px',
  _10 = '10px',
  _12 = '12px',
  _16 = '16px',
  _20 = '20px',
  _24 = '24px',
  _999 = '999px',
}
